import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'antd';

FormItem.propTypes = {
  label: PropTypes.string,
  required: PropTypes.bool,
  error: PropTypes.string,
  layout: PropTypes.object,
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
};

FormItem.defaultProps = {
  label: '',
  required: false,
  error: '',
  layout: {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
  },
};

function FormItem(props) {
  const { label, error, required, layout } = props;
  return (
    <Form.Item
      {...layout}
      colon={false}
      label={label}
      required={required}
      validateStatus={error ? 'error' : null}
      help={error}
    >
      {props.children}
    </Form.Item>
  );
}

export default FormItem;



// WEBPACK FOOTER //
// ./src/components/BaseForm/FormItem.js